import React, { useState, useEffect } from "react";
import { IMG } from "../../../assets";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
// import style from "./Insurance.css";

export default function Insurance() {
  const [isVisible, setIsVisible] = useState(false);
  const [secondRef, inView] = useInView({ triggerOnce: false, threshold: 0.2 });

  const listItemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: (index) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: index * 0.1,
        duration: 0.4,
        ease: "easeOut",
      },
    }),
    hover: {
      scale: 1.02,
      opacity: 0.9,
      transition: { duration: 0.2 },
    },
  };

  const array1 = {
    txt1: "Al-Ahleia Insurance Company",
    txt2: "Oriental Insurance Co",
    txt3: "GLOBAL BENEFITS GROUP (GBG)",
    txt4: "National Life & General Insurance Co.",
    txt5: "WAPMED – HEALTH 360",
  };

  const array2 = {
    txt6: "Boubyan Takaful Insurance Co.",
    txt7: "T'azur Taakful Insurance Co.",
    txt8: "KFH Takaful Insurance",
    txt9: "Gulf Insurance & Re-Insurance Co.",
    txt10: "BUPA Arabia Medical Insurance",
  };

  const array3 = {
    txt11: "GIG Takaful Unit / Elite",
    txt12: "Kuwait Insurance Co.",
    txt13: " GIG Takaful Unit / Elite",
    txt14: "Enaya Insurance Co.",
    txt16: "National Life & General Insurance Co.",
  };

  const textAnimation = {
    hidden: { opacity: 0, y: 25 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5 } },
  };

  useEffect(() => {
    if (inView) {
      setIsVisible(true); // Trigger animation when the section is in view
    } else {
      setIsVisible(false); // Optionally reset visibility if it goes out of view
    }
  }, [inView]);

  useEffect(() => {
    window.scrollTo(0, 0); // Ensures the page scrolls to the top on mount
  }, []);

  return (
    <div className="bg-secondary font-poppins -tracking-tighter overflow-x-hidden lg:pt-[130px] pt-[100px]">
      <div className="bg-secondary h-auto flex justify-center items-center px-5 py-[6%]">
        <div className="lg:flex max-w-screen-2xl w-full h-auto">
          <motion.div
            initial="hidden"
            // animate={controls}
            animate={isVisible ? "visible" : "hidden"}
            variants={textAnimation}
            ref={secondRef}
            className="w-full flex flex-col lg:items-start justify-center items-center text-white 2xl:text-[78px] md:text-7xl text-5xl font-bold mb-[4%] lg:mb-0"
          >
            <p>Insurance &</p>
            <p>Financing</p>
            <p>Solutions</p>
          </motion.div>
          <div>
            <img src={IMG.INSURANCE} alt="" className="object-contain" />
          </div>
        </div>
      </div>

      <div
        className="bg-white flex flex-col items-center justify-center"
        // ref={sectionRef}
      >
        <div className="max-w-screen-2xl w-full h-full bg-gren">
          <div className="flex flex-col lg:flex-row 2xl:px-[9%] md:px-[2%] px-[6%] pt-[4%]">
            <div className="text-[60px] text-[#35373a] flex flex-col justify-center md:items-center ">
              <p className="font-extralight ">Insurance</p>
              <p className="font-bold 2xl:mt-[-10%] lg:mt-[-10%] md:mt-[-3%] mt-[-5%]">
                Partners
              </p>
            </div>
            <div className="lg:pl-[4%] flex flex-col lg:items-start justify-center text-start mt-[5%] lg:mt-0 w-full">
              <p>
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos. Nullam condimentum ex nec
                euismod pellentesque. In pretium finibus sagittis. Class aptent
                taciti sociosqu ad litora torquent.
              </p>
            </div>
          </div>
        </div>
        <div className="bg-lue max-w-screen-2xl w-full h-full">
          <div className="flex flex-col lg:flex-row 2xl:px-[9%] md:px-[2%] px-[6%] py-[5%]">
            {/* <div className="text-7xl text-[#35373a] flex flex-col justify-center items-center">
                            <img src={IMG.INSURANCE2} alt="" />
                        </div> */}
            <div className="lg:flex items-center justify-start w-full lg:mt-0 gap-2">
              <div className="bg-re flex items-center">
                <ul className="">
                  {Object.values(array1).map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center text-[#35373a] hover:text-black-2 mb-3"
                      custom={index}
                      initial="hidden"
                      animate={isVisible ? "visible" : "hidden"}
                      whileHover="hover"
                      variants={listItemVariants}
                    >
                      <img
                        src={IMG.SQUARE}
                        alt="arrow"
                        className="mr-2 object-contain w-[2%]"
                      />
                      <p className="lg:text-base xl:text-lg md:text-[20px] text-[14px] font-bold md:leading-[45px] text-nowrap">
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex items-center bg-gren">
                <ul>
                  {Object.values(array2).map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center text-[#35373a] hover:text-black-2 mb-3"
                      custom={index}
                      initial="hidden"
                      animate={isVisible ? "visible" : "hidden"}
                      whileHover="hover"
                      variants={listItemVariants}
                    >
                      <img
                        src={IMG.SQUARE}
                        alt="arrow"
                        className="mr-2 object-contain w-[2%]"
                      />
                      <p className="lg:text-base xl:text-lg md:text-[20px] text-[14px] font-bold md:leading-[45px] text-nowrap">
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex items-center bg-heo">
                <ul>
                  {Object.values(array3).map((item, index) => (
                    <li
                      key={index}
                      className="flex items-center text-[#35373a] hover:text-black-2 mb-3"
                      custom={index}
                      initial="hidden"
                      animate={isVisible ? "visible" : "hidden"}
                      whileHover="hover"
                      variants={listItemVariants}
                    >
                      <img
                        src={IMG.SQUARE}
                        alt="arrow"
                        className="mr-2 object-contain w-[2%]"
                      />
                      <p className="lg:text-base xl:text-lg md:text-[20px] text-[14px] font-bold md:leading-[45px] text-nowrap ">
                        {item}
                      </p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="bg-rd flex items-center justify-center w-full 2xl:px-[9%] px-[2%] pb-[5%]">
            <hr className="text-[#DFDFDF] w-full h-[4px]" />
          </div>
        </div>

        <div className="max-w-screen-2xl w-full h-full pb-[4%]">
          <div className="flex flex-col lg:flex-row 2xl:px-[9%] md:px-[2%] px-[6%]">
            <div className="text-[60px] text-[#35373a] flex flex-col justify-center md:items-center lg:col-span-2">
              <p className="font-extralight">Financing </p>
              <p className="font-bold 2xl:mt-[-10%] lg:mt-[-10%] md:mt-[-3%] mt-[-5%]">
                Solutions
              </p>
            </div>
            <div className="lg:pl-[4%] flex flex-col lg:items-start justify-center text-start mt-[5%] lg:mt-0 w-full">
              <p>
                Class aptent taciti sociosqu ad litora torquent per conubia
                nostra, per inceptos himenaeos. Nullam condimentum ex nec
                euismod pellentesque. In pretium finibus sagittis. Class aptent
                taciti sociosqu ad litora torquent.
              </p>
            </div>
          </div>
          <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 2xl:px-[9%] md:px-[2%] px-[8%] gap-15 md:gap-12 lg:gap-25 py-[5%] mt-[8%] md:mt-0">
            <div className=" flex items-center justify-center">
              <img
                src={IMG.LOGO1}
                alt=""
                className="lg:w-full w-[60%] object-contain "
              />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={IMG.LOGO2}
                alt=""
                className="lg:w-full w-[60%] object-contain"
              />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={IMG.LOGO3}
                alt=""
                className="lg:w-full w-[65%] object-contain"
              />
            </div>
            <div className="flex items-center justify-center">
              <img
                src={IMG.LOGO4}
                alt=""
                className="lg:w-full w-[60%] object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
